<div class="card-contact-panel">

    <div class="dialog-header">
        <div class="dialog-header-icon">
            <i class="fal fa-paper-plane"></i>
        </div>
        <p class="title-change">¿En qué podemos ayudarte?</p>
        <button class="btn-close-dialog" mat-dialog-close><i class="fa-light fa-times"></i></button>
    </div>

    <form [formGroup]="contactForm">

        <div class="field-group">
            <label class="field-label">ASUNTO</label>
            <div class="bloque-change-input subject-input" [class.input-error]="error && contactForm.get('subject').invalid">
                <input class="w-100" type="text" placeholder="¿Sobre qué trata tu consulta?" formControlName="subject" />
            </div>
        </div>

        <div class="field-group">
            <label class="field-label">MENSAJE</label>
            <div class="bloque-change-input textarea-input" [class.input-error]="error && contactForm.get('body').invalid">
                <textarea #textarea class="w-100" placeholder="Cuéntanos tu problema o consulta con el mayor detalle posible."
                    maxlength="2500" formControlName="body"></textarea>
                <span class="char-count">{{contactForm.get('body').value?.length || 0}} / 2500</span>
            </div>
        </div>

        <p class="error-msg" *ngIf="error && contactForm.invalid">Por favor, rellena todos los campos.</p>

        <div class="d-flex justify-content-center btn-change">
            <button class="primary-button solid w-50" (click)="sendContact()">Enviar mensaje</button>
        </div>

    </form>

</div>
